export interface FromPrice {
  amount: number;
  promotion: number;
  hasPromotion: boolean;
}

const toAmount = (value: any): number => {
  const amount = typeof value === 'string' ? parseFloat(value) : value;

  return typeof amount === 'number' && isFinite(amount) ? amount : 0;
};

/**
 * Resolve a product's "from" price together with its promotional counterpart.
 *
 * The promotion is only honoured when it undercuts the regular from price, so an
 * expired or mistyped promotional price never renders as a discount.
 */
export const resolveFromPrice = (amount: any, promotion: any): FromPrice => {
  const regular = toAmount(amount);
  const special = toAmount(promotion);
  const hasPromotion = regular > 0 && special > 0 && special < regular;

  return {
    amount: regular,
    promotion: hasPromotion ? special : 0,
    hasPromotion
  };
};

/**
 * Resolve the from price straight from a Solr product document.
 */
export const resolveProductFromPrice = (product: object): FromPrice => resolveFromPrice(
  product?.['ialgemeen_vanafprijs'],
  product?.['ialgemeen_actieprijs']
);
